import React, { useEffect, useState } from "react";
import constusbanner from "../../Assests/back-header-1.png";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { Link } from "react-router-dom";
import Aos from "aos";

export default function ContactusPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleformsubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://handarealtor.ca/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          phone,
          message,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        console.log("Form Submitted Successfully", data);

        setName("");
        setEmail("");
        setPhone("");
        setMessage("");
      } else {
        console.log("Submission Failed", data);
      }
    } catch (error) {
      console.log("Something Went Wrong", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div>
      <section
        className="contact-banner d-flex align-items-center justify-content-center text-center text-white"
        style={{
          backgroundImage: `url(${constusbanner})`,
        }}
      >
        <div className="overlay"></div>

        <div className="content w-100 container pt-5">
          <h1 className="text-start banner-title">Contact Us</h1>
        </div>
      </section>

      <section className="properties-section">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
              <p
                className="text-start text-uppercase text-muted"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                CONTACT INFO
              </p>

              <h2
                className="text-start mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Our Experts Are Ready to Work With You
              </h2>

              <p
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Get in touch with our team for trusted guidance, responsive
                communication, and local Nashville market expertise.
              </p>

              <div className="d-flex align-items-center mt-3">
                <FaPhoneAlt className="me-2 text-dark fs-3" />
                <div>
                  <h5 className="mb-0">Phone</h5>
                  <Link
                    to="tel:+16479876291"
                    className="text-decoration-none "
                    style={{ color: "#7A7A7A" }}
                  >
                    +1 (647) 987-6291
                  </Link>
                </div>
              </div>
              <div className="d-flex align-items-center mt-3">
                <IoMail className="me-2 text-dark fs-3" />
                <div>
                  <h5 className="mb-0">Email</h5>
                  <Link
                    to="mailto:handa.realtor@gmail.com"
                    className="text-decoration-none "
                    style={{ color: "#7A7A7A" }}
                  >
                    handa.realtor@gmail.com
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-3 mt-md-5 d-flex justify-content-xl-end">
              <form
                className="shadow rounded-3 p-4 w-100 w-md-75"
                onSubmit={handleformsubmit}
              >
                <div className="row">
                  <div className="col-12 mb-3">
                    <input
                      type="text"
                      className="form-control rounded-3"
                      placeholder="Your Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="col-12  mb-3">
                    <input
                      type="email"
                      className="form-control rounded-3"
                      placeholder="Email Address"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="col-12  mb-3">
                    <input
                      type="tel"
                      className="form-control rounded-3"
                      placeholder="Phone Number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <textarea
                      className="form-control rounded-3"
                      rows="6"
                      placeholder="Your Message"
                      required
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="col-12 text-center">
                    <button type="submit" className="btn btn-dark px-4 w-100">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
